export default __webpack_public_path__ + "maps-guides-styles-expressions-zoom-low-960-a6f9d3dbc49b1babc3b9dd5de618e76b.png";